<template>

</template>

<script>
    export default {
        name: "BinaDuyuru"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Comp/BinaDuyuru.vue